import { DEFAULT_A11Y_SETTINGS, type A11ySettings } from '@/lib/lyrra-a11y-settings';

/** Détecte une demande de retour aux réglages par défaut (voix ou texte). */
export function isA11yResetIntent(text: string): boolean {
  const t = text
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');

  if (!t) return false;

  const patterns = [
    /\bremettre\b.*\b(normal|defaut|standard|par defaut|d origine|initial)\b/,
    /\bretour\b.*\b(normal|defaut|standard)\b/,
    /\b(reinitialiser|reinitialise|reset)\b/,
    /\b(tout\s+)?(desactiver|enlever|retirer)\b.*\b(reglage|option|accessibilite)\b/,
    /\bplus\s+de\s+(reglage|option)\b/,
    /\bcomme\s+avant\b/,
    /\bback\s+to\s+(normal|default)\b/,
    /\breset\b.*\b(setting|accessibilit)/,
    /\bdefault\s+setting/,
    /\brestaurer\b.*\b(defaut|normal)\b/,
    /\bmode\s+normal\b/,
    /\baffichage\s+normal\b/,
    /\bstandard\b.*\b(accessibilite|reglage)\b/,
  ];

  return patterns.some((re) => re.test(t));
}

export function hasActiveNonDefaultA11ySettings(settings: A11ySettings): boolean {
  const d = DEFAULT_A11Y_SETTINGS;
  if (settings.highContrast !== d.highContrast) return true;
  if (settings.underlineLinks !== d.underlineLinks) return true;
  if (settings.dyslexiaFont !== d.dyslexiaFont) return true;
  if (settings.reducedMotion !== d.reducedMotion) return true;
  if (settings.keyboardNavigation !== d.keyboardNavigation) return true;
  if (settings.autoPlayImageDescriptionOnHover !== d.autoPlayImageDescriptionOnHover) return true;
  if (settings.mouseMagnifier !== d.mouseMagnifier) return true;
  if (settings.readingMask !== d.readingMask) return true;
  if (settings.speakOnSelection !== d.speakOnSelection) return true;
  if (settings.simplifiedTextMode !== d.simplifiedTextMode) return true;
  if (Math.abs(settings.fontScale - d.fontScale) > 0.01) return true;
  if (Math.abs(settings.lineHeight - d.lineHeight) > 0.01) return true;
  if (Math.abs(settings.letterSpacing - d.letterSpacing) > 0.001) return true;
  if (Math.abs(settings.wordSpacing - d.wordSpacing) > 0.001) return true;
  return false;
}
